import gql from 'graphql-tag';

export default gql`
    mutation StartStages($input: StartStagesInput) {
        startStages(input: $input) {
            errors
        }
    }
`;
